<template>
  <div>
    <v-dialog v-model="isError" width="auto">
      <v-card
        max-width="400"
        prepend-icon="mdi-alert-circle-outline"
        title="Fout"
      >
        <v-card-text>
          {{ error }}
        </v-card-text>
        <template v-slot:actions>
          <v-btn class="ms-auto" text="Ok" @click="error = null"></v-btn>
        </template>
      </v-card>
    </v-dialog>

    <v-dialog v-model="existsDialog" width="auto">
      <v-card
        max-width="400"
        prepend-icon="mdi-alert-circle-outline"
        :title="config.existsTitle"
      >
        <v-card-text>
          <div :v-if="config.existSubTitle">
            <h5>{{ config.existsSubTitle }}</h5>
            <v-divider></v-divider>
          </div>
          <div v-html="config.existsInfo"></div
        ></v-card-text>
        <template v-slot:actions>
          <v-btn
            class="ms-auto"
            text="Ok"
            @click="existsDialog = false"
          ></v-btn>
        </template>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isUpdating" width="auto">
      <v-card
        max-width="400"
        prepend-icon="mdi-alert-circle-outline"
        title="Registreren..."
      >
        <v-card-text>
          <div>
            <v-progress-circular indeterminate :size="60"></v-progress-circular>
          </div>
          <div>Even geduld...</div></v-card-text
        >
      </v-card>
    </v-dialog>

    <v-card :class="cardClass" elevation="8" max-width="1200" rounded="lg">
      <v-stepper
        alt-labels
        v-model="currentStep"
        :prev-text="getPrevStepText"
        :next-text="getNextStepText"
        :mobile="isMobile"
      >
        <v-stepper-header>
          <v-stepper-item
            :complete="isComplete(0)"
            :error="!isComplete(0)"
            :title="config.nameTitle"
            :subtitle="config.nameSubTitle"
            value="0"
          ></v-stepper-item>

          <v-divider></v-divider>
          <v-stepper-item
            :complete="isComplete(1)"
            :error="!isComplete(1)"
            :title="config.addressTitle"
            :subtitle="config.addressSubTitle"
            value="1"
          ></v-stepper-item>

          <v-divider></v-divider>
          <v-stepper-item
            :complete="isComplete(2)"
            :error="!isComplete(2)"
            :title="config.communicationTitle"
            :subtitle="config.communicationSubTitle"
            value="2"
          ></v-stepper-item>

          <v-divider v-if="showParentSteps"></v-divider>
          <v-stepper-item
            complete
            :title="config.fatherTitle"
            :subtitle="config.fatherSubTitle"
            value="3"
            v-if="showParentSteps"
          ></v-stepper-item>

          <v-divider v-if="showParentSteps"></v-divider>
          <v-stepper-item
            complete
            :title="config.motherTitle"
            :subtitle="config.motherSubTitle"
            value="4"
            v-if="showParentSteps"
          ></v-stepper-item>

          <v-divider></v-divider>
          <v-stepper-item
            :complete="isComplete(5)"
            :error="!isComplete(5)"
            :title="config.additionalTitle"
            :subtitle="config.additionalSubTitle"
            value="5"
          ></v-stepper-item>

          <v-divider></v-divider>
          <v-stepper-item
            complete
            :title="config.registeredTitle"
            :subtitle="config.registeredSubTitle"
            value="6"
          ></v-stepper-item>
        </v-stepper-header>

        <v-stepper-window>
          <v-stepper-window-item value="0">
            <v-sheet class="sheet">
              <v-card v-if="config.nameInfo" class="info" variant="text">
                <div v-html="config.nameInfo"></div>
                <v-divider></v-divider>
              </v-card>
              <v-text-field
                type="text"
                id="lastname"
                density="compact"
                variant="outlined"
                label="(Familie)naam"
                placeholder="Jouw (familie)naam"
                v-model.trim="member.lastName"
                @blur="clearValidity"
                @focus="clearValidity"
              ></v-text-field>
              <v-text-field
                type="text"
                id="firstname"
                density="compact"
                variant="outlined"
                label="Voornaam"
                placeholder="Jouw voornaam"
                v-model.trim="member.firstName"
                @blur="clearValidity"
                @focus="clearValidity"
              ></v-text-field>
              <v-text-field
                type="date"
                id="birthdate"
                density="compact"
                variant="outlined"
                label="Geboortedatum"
                placeholder="Jouw geboortedatum"
                v-model="member.birthDate"
                @blur="clearValidity"
                @focus="clearValidity"
              ></v-text-field>
              <v-combobox
                label="Sexe"
                density="compact"
                variant="outlined"
                placeholder="Sexe"
                v-model="member.gender"
                :items="['Man', 'Vrouw', 'X']"
                @blur="clearValidity"
                @focus="clearValidity"
              ></v-combobox>
            </v-sheet>
          </v-stepper-window-item>

          <v-stepper-window-item value="1">
            <v-sheet class="sheet">
              <v-card v-if="config.addressInfo" class="info" variant="text">
                <div v-html="config.addressInfo"></div>
                <v-divider></v-divider>
              </v-card>
              <v-text-field
                type="text"
                id="address"
                density="compact"
                variant="outlined"
                label="Adres"
                placeholder="Jouw adres"
                v-model.trim="member.address"
                @blur="clearValidity"
                @focus="clearValidity"
              ></v-text-field>
              <v-text-field
                type="text"
                id="zip"
                density="compact"
                variant="outlined"
                label="Postcode"
                placeholder="Jouw postcode"
                v-model.trim="member.zip"
                @blur="clearValidity"
                @focus="clearValidity"
              ></v-text-field>
              <v-text-field
                type="text"
                id="city"
                density="compact"
                variant="outlined"
                label="Gemeente"
                placeholder="Jouw gemeente"
                v-model.trim="member.city"
                @blur="clearValidity"
                @focus="clearValidity"
              ></v-text-field>
            </v-sheet>
          </v-stepper-window-item>

          <v-stepper-window-item value="2">
            <v-sheet class="sheet">
              <v-card
                v-if="config.communicationInfo"
                class="info"
                variant="text"
              >
                <div v-html="config.communicationInfo"></div>
                <v-divider></v-divider>
              </v-card>
              <v-text-field
                type="text"
                id="telephone"
                density="compact"
                variant="outlined"
                v-model.trim="member.telephone"
                label="Telefoon"
                placeholder="Jouw telefoon nummer"
                @blur="clearValidity"
                @focus="clearValidity"
              ></v-text-field>
              <v-text-field
                type="text"
                id="mobile"
                density="compact"
                variant="outlined"
                v-model.trim="member.mobile"
                label="Mobiel nummer"
                placeholder="Jouw mobiel nummer"
                @blur="clearValidity"
                @focus="clearValidity"
              ></v-text-field>
              <v-text-field
                type="email"
                id="email"
                density="compact"
                variant="outlined"
                label="E-mailadres"
                placeholder="Jouw e-mailadres"
                v-model.trim="member.email"
                @blur="clearValidity"
                @focus="clearValidity"
              ></v-text-field>
            </v-sheet>
          </v-stepper-window-item>

          <v-stepper-window-item value="3">
            <v-sheet class="sheet">
              <v-card v-if="config.fatherInfo" class="info" variant="text">
                <div v-html="config.fatherInfo"></div>
                <v-divider></v-divider>
              </v-card>
              <v-text-field
                type="text"
                id="lastnamefather"
                density="compact"
                variant="outlined"
                label="(Familie)naam (papa)"
                placeholder="(Familie)naam (papa)"
                v-model.trim="member.father.lastName"
                @blur="clearValidity"
                @focus="clearValidity"
              ></v-text-field>
              <v-text-field
                type="text"
                id="firstnamefather"
                density="compact"
                variant="outlined"
                label="Voornaam"
                placeholder="Voornaam"
                v-model.trim="member.father.firstName"
                @blur="clearValidity"
                @focus="clearValidity"
              ></v-text-field>
              <v-text-field
                type="text"
                id="telephonefather"
                density="compact"
                variant="outlined"
                v-model.trim="member.father.telephone"
                label="Telefoon"
                placeholder="Telefoon nummer"
                @blur="clearValidity"
                @focus="clearValidity"
              ></v-text-field>
              <v-text-field
                type="text"
                id="mobilefather"
                density="compact"
                variant="outlined"
                v-model.trim="member.father.mobile"
                label="Mobiel nummer"
                placeholder="Mobiel nummer"
                @blur="clearValidity"
                @focus="clearValidity"
              ></v-text-field>
              <v-text-field
                type="email"
                id="emailfather"
                density="compact"
                variant="outlined"
                v-model.trim="member.father.email"
                label="E-mail (papa)"
                placeholder="E-mailadres van papa"
                @blur="clearValidity"
                @focus="clearValidity"
              ></v-text-field>
            </v-sheet>
          </v-stepper-window-item>

          <v-stepper-window-item value="4">
            <v-sheet class="sheet">
              <v-card v-if="config.motherInfo" class="info" variant="text">
                <div v-html="config.motherInfo"></div>
                <v-divider></v-divider>
              </v-card>
              <v-text-field
                type="text"
                id="lastnamemother"
                density="compact"
                variant="outlined"
                label="(Familie)naam (mama)"
                placeholder="(Familie)naam (mama)"
                v-model.trim="member.mother.lastName"
                @blur="clearValidity"
                @focus="clearValidity"
              ></v-text-field>
              <v-text-field
                type="text"
                id="firstnamemother"
                density="compact"
                variant="outlined"
                label="Voornaam"
                placeholder="Voornaam"
                v-model.trim="member.mother.firstName"
                @blur="clearValidity"
                @focus="clearValidity"
              ></v-text-field>
              <v-text-field
                type="text"
                id="telephonemother"
                density="compact"
                variant="outlined"
                v-model.trim="member.mother.telephone"
                label="Telefoon"
                placeholder="Telefoon nummer"
                @blur="clearValidity"
                @focus="clearValidity"
              ></v-text-field>
              <v-text-field
                type="text"
                id="mobilemother"
                density="compact"
                variant="outlined"
                v-model.trim="member.mother.mobile"
                label="Mobiel nummer"
                placeholder="Mobiel nummer"
                @blur="clearValidity"
                @focus="clearValidity"
              ></v-text-field>
              <v-text-field
                type="email"
                id="emailmother"
                density="compact"
                variant="outlined"
                v-model.trim="member.mother.email"
                label="E-mail (mama)"
                placeholder="E-mailadres van mama"
                @blur="clearValidity"
                @focus="clearValidity"
              ></v-text-field>
            </v-sheet>
          </v-stepper-window-item>

          <v-stepper-window-item value="5">
            <v-sheet class="sheet">
              <v-card v-if="config.additionalInfo" class="info" variant="text">
                <div v-html="config.additionalInfo"></div>
                <v-divider></v-divider>
              </v-card>

              <div :class="levelClass">
                <div class="level">
                  <v-autocomplete
                    density="compact"
                    variant="outlined"
                    v-model="member.playerLevel"
                    :items="getPlayerLevels"
                    item-value="id"
                    item-title="description"
                    label="Speelniveau"
                    no-data-text="-"
                    placeholder="Speelniveau"
                    single-line
                    chips
                    closable-chips
                  >
                    <template v-slot:chip="{ props, item }">
                      <v-chip
                        v-bind="props"
                        :text="item.raw.description"
                      ></v-chip>
                    </template>
                    <template v-slot:item="{ props, item }">
                      <v-list-item
                        v-bind="props"
                        :title="item.raw.description"
                      ></v-list-item>
                    </template>
                  </v-autocomplete>
                </div>
                <div class="exp">
                  <v-text-field
                    type="number"
                    id="yearsofexperience"
                    density="compact"
                    variant="outlined"
                    v-model.trim="member.yearsOfExperience"
                    min="0"
                    max="100"
                    label="Aantal jaar speelervaring"
                    placeholder="#jr"
                    @blur="clearValidity"
                    @focus="clearValidity"
                  ></v-text-field>
                </div>
                <v-checkbox
                  v-model="member.ranked"
                  label="Heb of had je ooit een klassement"
                >
                </v-checkbox>
                <div class="ranking">
                  <v-autocomplete
                    density="compact"
                    variant="outlined"
                    v-model="member.ranking"
                    :items="getRankings"
                    item-value="ranking"
                    item-title="ranking"
                    label="Klassement"
                    no-data-text="-"
                    placeholder="Klassement"
                    single-line
                    chips
                    closable-chips
                    v-if="member.ranked"
                  >
                    <template v-slot:chip="{ props, item }">
                      <v-chip v-bind="props" :text="item.raw.ranking"></v-chip>
                    </template>
                    <template v-slot:item="{ props, item }">
                      <v-list-item
                        v-bind="props"
                        :title="item.raw.ranking"
                      ></v-list-item>
                    </template>
                  </v-autocomplete>
                </div>
              </div>

              <div :class="clubClass">
                <v-checkbox
                  v-model="member.subscribedInOtherClub"
                  label="Aangesloten bij een andere club"
                >
                </v-checkbox>
                <v-text-field
                  type="text"
                  id="otherclub"
                  density="compact"
                  variant="outlined"
                  v-model.trim="member.otherClub"
                  label="Bij (andere) club"
                  placeholder="(Andere) club"
                  @blur="clearValidity"
                  @focus="clearValidity"
                  v-if="member.subscribedInOtherClub"
                ></v-text-field>
              </div>

              <v-autocomplete
                multiple
                density="compact"
                variant="outlined"
                v-model="member.playerMoments"
                :items="getPlayerMoments"
                item-value="id"
                item-title="name"
                label="Jouw geprefereerde speelmoment(en)"
                no-data-text="Geen"
                placeholder="Jouw geprefereerde speelmoment(en)"
                single-line
                chips
                closable-chips
                v-if="askForPlayerMoments"
              >
                <template v-slot:chip="{ props, item }">
                  <v-chip v-bind="props" :text="item.raw.name"></v-chip>
                </template>
                <template v-slot:item="{ props, item }">
                  <v-list-item
                    v-bind="props"
                    :subtitle="item.raw.info"
                    :title="item.raw.name"
                  ></v-list-item>
                </template>
              </v-autocomplete>

              <v-autocomplete
                multiple
                density="compact"
                variant="outlined"
                v-model="member.interests"
                :items="getInterests"
                item-value="id"
                item-title="question"
                label="Jouw (bijkomende) interesses"
                no-data-text="-"
                placeholder="Jouw (bijkomende) interesses"
                single-line
                chips
                closable-chips
                v-if="thereAreInterests"
              >
                <template v-slot:chip="{ props, item }">
                  <v-chip v-bind="props" :text="item.raw.question"></v-chip>
                </template>
                <template v-slot:item="{ props, item }">
                  <v-list-item
                    v-bind="props"
                    :title="item.raw.question"
                  ></v-list-item>
                </template>
              </v-autocomplete>

              <div v-if="enterRemarks">
                <v-textarea
                  id="remarks"
                  placeholder="Heb je aan- of opmerkingen"
                  v-model="member.remarks"
                  no-resize
                  density="compact"
                  variant="outlined"
                  rows="2"
                ></v-textarea>
              </div>

              <div v-if="checkPrivacy">
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-title>
                      <v-checkbox-btn
                        v-model="member.privacyCheck"
                        label="Ik ga akkoord met het privacybeleid"
                      >
                      </v-checkbox-btn>
                    </v-expansion-panel-title>
                    <v-expansion-panel-text>
                      Ik heb de algemene voorwaarden en het privacybeleid, te
                      vinden op onze website, gelezen en ga hiermee
                      akkoord</v-expansion-panel-text
                    >
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </v-sheet>
          </v-stepper-window-item>

          <v-stepper-window-item value="6">
            <v-sheet class="sheet">
              <v-card v-if="config.registeredInfo" class="info" variant="text">
                <div v-html="config.registeredInfo"></div>
              </v-card>
            </v-sheet>
          </v-stepper-window-item>
        </v-stepper-window>

        <v-stepper-actions
          @click:prev="gotoPreviousStep"
          @click:next="gotoNextStep"
          :disabled="disabledButtons"
          ><v-btn>CLOSE</v-btn></v-stepper-actions
        >
      </v-stepper>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "HomePage",
  data() {
    return {
      isUpdating: false,
      config: null,
      currentStep: 0,
      error: null,
      existsDialog: false,

      member: {
        lastName: null,
        firstName: null,
        birthDate: null,
        gender: null,
        address: null,
        zip: null,
        city: null,
        telephone: null,
        mobile: null,
        email: null,
        father: {
          lastName: null,
          firstName: null,
          telephone: null,
          mobile: null,
          email: null,
        },
        mother: {
          lastName: null,
          firstName: null,
          telephone: null,
          mobile: null,
          email: null,
        },
        playerLevel: null,
        yearsOfExperience: null,
        ranked: null,
        ranking: null,
        subscribedInOtherClub: null,
        otherClub: null,
        playerMoments: [],
        interests: [],
        remarks: null,
        privacyCheck: false,
      },

      searchInterest: "",
    };
  },
  computed: {
    isMobile() {
      return this.$isMobile();
    },
    cardClass() {
      if (this.$isMobile() == true) {
        return "cardmobile";
      }

      return "mx-auto pa-12 pb-8 card";
    },
    levelClass() {
      if (this.$isMobile() == true) {
        return "";
      }

      return "flex";
    },
    clubClass() {
      if (this.$isMobile() == true) {
        return "";
      }

      return "flex";
    },
    isError() {
      return this.error ? true : false;
    },
    memberExists() {
      return true;
      // return this.$store.getters["memberExists"];
    },
    age() {
      if (this.member.birthDate == null) {
        return "";
      }

      let birthDate = new Date(this.member.birthDate);
      let today = new Date();

      let age = today.getFullYear() - birthDate.getFullYear();
      let monthDiff = today.getMonth() - birthDate.getMonth();
      let dayDiff = today.getDate() - birthDate.getDate();

      // Adjust if birthday hasn't occurred yet this year
      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--;
      }

      return age;
    },
    showParentSteps() {
      return this.config.parentInformation == 1 &&
        this.member.birthDate != null &&
        this.age < 18
        ? true
        : false;
    },
    currentTab() {
      // return the current selected tab, it can differ from currentStep cause of hidden tabs/steps
      if (this.currentStep == 0) {
        return "name";
      }
      if (this.currentStep == 1) {
        return "address";
      }
      if (this.currentStep == 2) {
        return "communication";
      }
      if (this.currentStep == 3) {
        if (this.showParentSteps) {
          return "father";
        } else {
          return "extra";
        }
      }
      if (this.currentStep == 4) {
        if (this.showParentSteps) {
          return "mother";
        } else {
          return "registered";
        }
      }
      if (this.currentStep == 5) {
        return "extra";
      }
      if (this.currentStep == 6) {
        return "registered";
      }

      return "";
    },
    getPrevStepText() {
      if (this.$isMobile()) {
        return "<";
      }

      return "Vorige stap";
    },
    getNextStepText() {
      if (this.currentTab == "extra") {
        return "Aanmelden";
      }

      if (this.currentTab == "registered") {
        return "Sluit";
      }

      if (this.$isMobile()) {
        return ">";
      }

      return "Volgende stap";
    },
    disabledButtons() {
      if (this.currentStep == 0) {
        return "prev";
      }

      const tab = this.currentTab;
      if (tab == "registered") {
        return "prev";
      }

      return false;
    },
    thereAreInterests() {
      const questions = this.$store.getters["questions"];
      return questions && questions.length > 0 ? true : false;
    },
    getInterests() {
      const questions = this.$store.getters["questions"];
      const list = [];
      questions.forEach((question) => {
        list.push({
          id: question.id,
          question: question.question,
        });
      });

      return list;
    },
    askForPlayerMoments() {
      const config = this.$store.getters["config"];
      const playerMoments = this.$store.getters["playerMoments"];
      return config &&
        config.playerMomentSelection == 1 &&
        playerMoments &&
        playerMoments.length > 0
        ? true
        : false;
    },
    getPlayerLevels() {
      const playerLevels = this.$store.getters["playerLevels"];
      const list = [];
      playerLevels.forEach((playerLevel) => {
        list.push({
          id: playerLevel.id,
          description: playerLevel.description,
        });
      });

      return list;
    },
    getPlayerMoments() {
      const playerMoments = this.$store.getters["playerMoments"];
      const list = [];
      playerMoments.forEach((playerMoment) => {
        list.push({
          id: playerMoment.id,
          name: playerMoment.description + " (" + playerMoment.code + ")",
          info: playerMoment.weekDay + " " + playerMoment.timePeriod,
        });
      });

      return list;
    },
    getRankings() {
      const rankings = this.$store.getters["rankings"];
      const list = [];
      rankings.forEach((ranking) => {
        list.push({
          id: ranking.id,
          ranking: ranking.ranking,
        });
      });

      return list;
    },
    enterRemarks() {
      const config = this.$store.getters["config"];
      return config.remarksEntry == 1 ? true : false;
    },
    checkPrivacy() {
      const config = this.$store.getters["config"];
      return config.privacyCheck == 1 ? true : false;
    },
  },
  methods: {
    gotoPreviousStep() {
      this.currentStep = this.currentStep - 1;
    },
    async gotoNextStep() {
      // Name, birthdate & sex
      if (this.currentTab == "name") {
        if (this.member.lastName == null || this.member.lastName.length == 0) {
          this.error = "Gelieve je (familie)naam in te brengen!";
          return;
        }

        if (
          this.member.firstName == null ||
          this.member.firstName.length == 0
        ) {
          this.error = "Gelieve je voornaam in te brengen!";
          return;
        }

        if (this.member.birthDate == null) {
          this.error = "Gelieve je geboortedatum in te brengen!";
          return;
        }

        const age = this.age;
        if (age < 2 || age > 110) {
          this.error =
            "De ingebrachte geboortedatum lijkt niet echt plausibel?";
          return;
        }

        if (this.member.gender == null || this.member.gender.length == 0) {
          this.error = "Gelieve je sexe aan te geven!";
          return;
        }

        // Does this member already exists?
        try {
          await this.$store.dispatch("memberExists", {
            lastName: this.member.lastName,
            firstName: this.member.firstName,
            birthDate: this.member.birthDate,
          });
        } catch (err) {
          this.error =
            err.message ||
            "Er trad een fout op bij het nazien of deze fiche reeds bestaat";
        }

        const memberExists = this.$store.getters["memberExists"];
        if (memberExists == true) {
          this.existsDialog = true;
          return;
        }
      }

      // Address
      if (this.currentTab == "address") {
        if (this.member.address == null || this.member.address.length == 0) {
          this.error = "Gelieve je adres op te geven!";
          return;
        }

        if (this.member.zip == null || this.member.zip.length == 0) {
          this.error = "Gelieve je postcode op te geven!";
          return;
        }

        if (this.member.city == null || this.member.city.length == 0) {
          this.error = "Gelieve je gemeente op te geven!";
          return;
        }
      }

      // Email, phone
      if (this.currentTab == "communication") {
        if (
          this.member.email == null ||
          this.member.email.length == 0 ||
          this.member.email.includes("@") == false
        ) {
          this.error = "Gelieve je e-mailadres op te geven!";
          return;
        }

        if (this.member.mobile == null || this.member.mobile.length == 0) {
          this.error = "Gelieve je mobiel nummer op te geven!";
          return;
        }
      }

      // Additional info, if privacycheck is enabled it needs to be checked
      if (this.currentTab == "extra") {
        const config = this.$store.getters["config"];
        if (config.privacyCheck == 1 && this.member.privacyCheck == false) {
          this.error = "Geef aan dat je akkoord gaat met het privacybeleid";
          return;
        }

        // Register the new member
        this.isUpdating = true;
        let gender = "M";
        if (this.member.gender == "Vrouw") {
          gender = "F";
        }
        if (this.member.gender == "X") {
          gender = "X";
        }

        let ranking = "";
        if (this.member.ranked == true) {
          ranking = this.member.ranking;
        }

        let tags = null;
        if (this.member.interests && this.member.interests.length > 0) {
          tags = "";
          const questions = this.$store.getters["questions"];
          this.member.interests.forEach((interest) => {
            if (tags) {
              tags = tags + "|";
            }
            tags = tags + questions[interest - 1].tag;
          });
        }

        let playerMoments = null;
        if (this.member.playerMoments && this.member.playerMoments.length > 0) {
          playerMoments = "";
          const playerMomentsList = this.$store.getters["playerMoments"];
          this.member.playerMoments.forEach((playerMoment) => {
            if (playerMoments) {
              playerMoments = playerMoments + "|";
            }
            let code = "";
            playerMomentsList.forEach((pm) => {
              if (pm.id == playerMoment) {
                code = pm.code;
              }
            });
            if (code) {
              playerMoments = playerMoments + code;
            }
          });
        }

        try {
          await this.$store
            .dispatch("register", {
              lastName: this.member.lastName,
              firstName: this.member.firstName,
              birthDate: this.member.birthDate,
              gender: gender,
              address: this.member.address,
              zip: this.member.zip,
              city: this.member.city,
              telephone: this.member.telephone,
              mobile: this.member.mobile,
              emailPrivate: this.member.email,
              lastNameFather: this.member.father.lastName,
              firstNameFather: this.member.father.firstName,
              telephoneFather: this.member.father.telephone,
              mobileFather: this.member.father.mobile,
              emailFather: this.member.father.email,
              lastNameMother: this.member.mother.lastName,
              firstNameMother: this.member.mother.firstName,
              telephoneMother: this.member.mother.telephone,
              mobileMother: this.member.mother.mobile,
              emailMother: this.member.mother.email,
              tags: tags,
              playerLevel: this.member.playerLevel,
              yearsOfExperience: this.member.yearsOfExperience,
              ranking: ranking,
              isMemberOfOtherClub: this.member.subscribedInOtherClub ? 1 : 0,
              otherClub: this.member.subscribedInOtherClub
                ? this.member.otherClub
                : null,
              playerMoments: playerMoments,
              remark: this.member.remarks,
              sendMail: config.sendMail,
            })
            .then(() => {
              const registered = this.$store.getters["registered"];
              if (registered == false) {
                this.isUpdating = false;
                this.error =
                  "Je registratie kon niet correct worden doorgestuurd!  Probeer later opnieuw.";
                return;
              }
            });
        } catch (err) {
          this.isUpdating = false;
          this.error =
            err.message ||
            "Fout bij het registreren van je aanmelding! Probeer later opnieuw.";
          return;
        }

        this.isUpdating = false;
      }

      // Registered
      if (this.currentTab == "registered") {
        const config = this.$store.getters["config"];
        window.open(config.clubUrl, "_self");
        return;
      }

      this.currentStep = this.currentStep + 1;
    },
    isComplete(step) {
      // Name, birthdate & sex
      if (step == 0) {
        if (this.member.lastName == null || this.member.lastName.length == 0) {
          return false;
        }

        if (
          this.member.firstName == null ||
          this.member.firstName.length == 0
        ) {
          return false;
        }

        if (this.member.birthDate == null) {
          return false;
        }

        if (this.member.gender == null || this.member.gender.length == 0) {
          return false;
        }
      }

      // Address
      if (step == 1) {
        if (this.member.address == null || this.member.address.length == 0) {
          return false;
        }

        if (this.member.zip == null || this.member.zip.length == 0) {
          return false;
        }

        if (this.member.city == null || this.member.city.length == 0) {
          return false;
        }
      }

      // Email, phone
      if (step == 2) {
        if (this.member.email == null || this.member.email.length == 0) {
          return false;
        }

        if (this.member.mobile == null || this.member.mobile.length == 0) {
          return false;
        }
      }

      return true;
    },
    clearValidity() {
      this.error = null;
    },
  },
  created() {
    this.config = this.$store.getters["config"];
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.error {
  text-align: left;
  margin: 20px auto;
}

.card {
  overflow-y: auto;
  height: 700px;
}

.cardmobile {
  overflow-y: auto;
  height: 700px;
}

.sheet {
  margin-top: 6px;
}

.flex {
  display: flex;
  align-items: center;
  column-gap: 10px;
  margin-top: -10px;
  margin-bottom: -20px;
}

.info {
  margin-bottom: 9px;
}

.exp {
  width: 200px;
}

.ranking {
  width: 150px;
}

.level {
  width: 250px;
}
</style>
